export default "__VITE_ASSET__CUfj77G4__"